import { EditSettingsAction } from '@leverege/molten/data-viewers'
import { ItemEditor } from '@leverege/ui-attributes'

export default new EditSettingsAction( {
  id : 'ps.dataViewers.rooms.RoomCardDataViewer',
  matches : { use : 'actionBar', client : 'RoomCardDataViewer' },
  editor : ItemEditor,
  title : 'Room Card Editor',
  versionType : 'roomsCard',
  editorProps : ( opts ) => {
    const { delegate, objectType, blueprint, relationship } = opts.context?.clientProps || {}
    return { delegate, objectType, blueprint, relationship }
  }
} )
